import { get, patch, post } from '../../utils/http';

export const fetchSuppliers = ({ accountId, clientBranchId }) =>
  get(`/accounts/${accountId}/suppliers`, { clientBranchId });

export const addSupplier = ({ accountId, ...params }) => post(`/accounts/${accountId}/suppliers`, params);

export const fetchSupplier = ({ accountId, supplierId }) => get(`/accounts/${accountId}/suppliers/${supplierId}`);

export const updateSupplier = ({ accountId, supplierId, ...params }) =>
  patch(`/accounts/${accountId}/suppliers/${supplierId}`, params);

export const fetchSupplierOrders = ({ accountId, supplierId }) =>
  get(`/accounts/${accountId}/suppliers/${supplierId}/orders`);
